import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from '@core/services/event-emitter.service';
import svgIconList from 'assets/icons.json';
import { environment } from '@env/environment';


@Component({
  selector: 'app-portal-navigation',
  templateUrl: './portal-navigation.component.html',
  styleUrls: ['./portal-navigation.component.scss']
})

export class PortalNavigationComponent implements OnInit {
  svg: any = svgIconList;
  member_KYC = null;
  userData = JSON.parse(localStorage.getItem('user_data'));
  verificationRejectedPending = localStorage.getItem('rejected_and_pending_verification');

  sitePrefix: string;
  hideReferralSite = ['BP77', 'BP9']; // Hide for other project

  constructor(
    private eventEmitterService: EventEmitterService,
) { }

  ngOnInit() {
    this.sitePrefix = environment.sitePrefix.toUpperCase();

    this.eventEmitterService.updateVerificationStorageEmitter.subscribe(() => {
      this.verificationRejectedPending = localStorage.getItem('rejected_and_pending_verification'); 
    });
    if(this.userData){
      this.member_KYC = this.userData.KYC;
    }
  }
}
